import { numberFormat } from 'shared/util'
import { Box, Stack, Typography, Chip, Button, Divider } from '@mui/material'
import { Popup } from 'react-leaflet'
import { SisetuResult } from "interface/sisetu"

type SisetuPopupProps = {
  sisetuList: SisetuResult[]
  onOpen: (sisetuCode: string) => void
  onClose: () => void
}
export const SisetuPopup = ({
  sisetuList,
  onOpen,
  onClose
}: SisetuPopupProps) => {
  if (sisetuList.length > 3) return <></>
  return (
    <Popup
      eventHandlers={{
        remove: onClose,
      }}
    >
      <Stack spacing={2}>
        {sisetuList.map((sisetu, i) => (
          <Stack key={`popup-sisetu-${i}-${sisetu.sisetuCode}`} spacing={1}>
            {i > 0 ? <Divider /> : <></>}
            <Box>
              <Typography variant="body1" component="div" color="text.primary">
                {sisetu.sisetuName}
              </Typography>
              <Typography
                variant="body2"
                component="div"
                color="text.secondary"
              >
                {sisetu.juusyo}
              </Typography>
              {sisetuList.length === 1 && (
                <Typography
                  variant="body2"
                  component="div"
                  color="text.secondary"
                >
                  {sisetu.tel}
                </Typography>
              )}
            </Box>
            <Stack
              direction="row"
              spacing={0.5}
              flexWrap="wrap"
              useFlexGap
              width="100%"
            >
              {sisetu.score?.dpc?.rank ? (
                <Chip
                  label={`DPC ${numberFormat(sisetu.score.dpc.rank)}位`}
                  color="dpc"
                  size="small"
                />
              ) : (
                <></>
              )}
              {sisetu.score?.cancer?.rank ? (
                <Chip
                  label={`がん ${numberFormat(sisetu.score.cancer.rank)}位`}
                  color="cancer"
                  size="small"
                />
              ) : (
                <></>
              )}
              {sisetu.score?.trial?.rank ? (
                <Chip
                  label={`治験 ${numberFormat(sisetu.score.trial.rank)}位`}
                  color="trial"
                  size="small"
                />
              ) : (
                <></>
              )}
              {sisetu.score?.journal?.rank ? (
                <Chip
                  label={`論文 ${numberFormat(sisetu.score.journal.rank)}位`}
                  color="journal"
                  size="small"
                />
              ) : (
                <></>
              )}
              {sisetu.score?.senmoni?.rank ? (
                <Chip
                  label={`専門医 ${numberFormat(sisetu.score.senmoni.rank)}位`}
                  color="senmoni"
                  size="small"
                />
              ) : (
                <></>
              )}
            </Stack>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                if (sisetu.sisetuCode) onOpen(sisetu.sisetuCode)
              }}
              size="small"
            >
              開く
            </Button>
          </Stack>
        ))}
      </Stack>
    </Popup>
  )
}
